import { RiGithubFill } from '@remixicon/react'
import styles from './home.module.css'
import { HomeHeading } from './presentation'

interface OpenSourceCTAProps {
  githubStars: number
}

export function OpenSourceCTA({ githubStars }: OpenSourceCTAProps) {
  const formattedGithubStars =
    githubStars >= 1000
      ? `${(Math.round(githubStars / 100) / 10).toFixed(1)}k`
      : `${githubStars}`
  const stats = [
    { value: '100k+', label: 'Deployments' },
    ...(githubStars > 0
      ? [{ value: formattedGithubStars, label: 'GitHub stars' }]
      : []),
    { value: '#1', label: 'Trending of the Day' }
  ]
  return (
    <section
      className={`${styles.section} ${styles.soft}`}
      aria-labelledby="home-oss-title"
    >
      <div className={`${styles.container} ${styles.oss}`}>
        <div>
          <HomeHeading
            id="home-oss-title"
            title="Open source. No investors. No nonsense."
          >
            Fully bootstrapped and built for its users. No investor pressure,
            just a product you can make your own.
          </HomeHeading>
          <a
            className={styles.link}
            href="https://github.com/heyform/heyform"
            target="_blank"
            rel="noreferrer"
          >
            <RiGithubFill aria-hidden="true" />
            Check us on GitHub
          </a>
        </div>
        <dl className={styles.stats}>
          {stats.map(stat => (
            <div className={styles.stat} key={stat.label}>
              <dt>{stat.label}</dt>
              <dd>{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
